/**
 * Email History Constants
 * Shared constants for the Email History feature
 */

// Debounce timing (in milliseconds)
export const DEBOUNCE_DELAY = 300;

// API limits
export const MAX_SCHEDULED_EMAILS_FETCH = 1000;
export const MAX_CAMPAIGNS_FETCH = 1000;

// Pagination defaults
export const DEFAULT_PAGE_SIZE = 25;
export const DEFAULT_PAGE = 0;

// Sort defaults
export const DEFAULT_SORT_BY = 'sendDate';
export const DEFAULT_SORT_ORDER = 'desc';

// Campaign sort fields
export const CAMPAIGN_SORT_FIELDS = [
  'campaignName',
  'lastSendDate',
  'totalEmailsSent',
  'deliveryRate',
  'openRate',
  'clickRate',
];

// Bulk email sort fields
export const BULK_EMAIL_SORT_FIELDS = [
  'subject',
  'sendDate',
  'attempted',
  'deliveryRate',
  'openRate',
  'clickRate',
];

// Individual email sort fields
export const INDIVIDUAL_EMAIL_SORT_FIELDS = [
  'emailAddress',
  'subject',
  'sendDate',
  'status',
];

// Page size options
export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

// Date range defaults
export const DEFAULT_DATE_RANGE_DAYS = 30;

